/**
 * public-router.js
 */

import React from 'react';
import {
  Switch,
  Route,
  useLocation,
} from "react-router-dom";
import Register from 'routing/routes/register';
import ResetPassword from 'routing/routes/misc/reset-password';
import { LiveTrackingContext } from 'components/tracking/live-tracking/live-tracking-context';
import TrackingDrawer from 'components/tracking/live-tracking/tracking-drawer';


export const anonymousRoutes = [
  '/get-started',
  '/reset-password',
  '/tracking'
];


export default function PublicRouter(props) {
  let location = useLocation();
  const { setIsTrackingOpen } = React.useContext(LiveTrackingContext);


  // open tracking drawer
  React.useEffect(() => {
    if (location.pathname === '/tracking') {
      setIsTrackingOpen(true);
    }
  }, [location.pathname, setIsTrackingOpen]);


  return (
    <>
      <Switch location={location}>

        {/* register */}
        <Route exact path='/get-started'>
          <Register />
        </Route>

        {/* create password */}
        <Route exact path='/create-password/:userId/:date/:token'>
          <ResetPassword isCreating={true} />
        </Route>

        {/* reset password */}
        <Route exact path='/reset-password/:userId/:date/:token'>
          <ResetPassword isCreating={false} />
        </Route>

        {/* anonymous tracking */}
        <Route exact path='/tracking'>
          <TrackingDrawer />
        </Route>

        <Route>
          {props.children}
        </Route>

      </Switch>
    </>
  );
}